import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Days',
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _toDisplayString((Math.round(__props.value * 10) / 10))
}
}

})